import { Injectable } from '@angular/core';
import { HttpBaseService } from './http-base.service';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class JobTypeService {

  constructor(private http: HttpBaseService) { }

  getJobTypes(offset?: string, limit?: any) {

    offset = offset ? '?offset=' + offset : '?offset=0';
    limit = limit ? '&limit=' + limit : '&limit=0';
    return this.http.get('jobCategory/' + offset + limit);
  }

  getGlobalJobTypes(offset?: string, limit?: any) {

    offset = offset ? '?offset=' + offset : '?offset=0';
    limit = limit ? '&limit=' + limit : '&limit=0';
    return this.http.get('jobCategory/global' + offset + limit);
  }

  getFirmJobType(firmId: string, all = false, offset?: any, limit?: any) {

    offset = offset ? '?offset=' + offset : '?offset=0';
    limit = limit ? '&limit=' + limit : '&limit=0';
    let allParam = all ? '&all=true' : '&all=false';

    return this.http.get('jobCategory/firm/'+firmId + offset + limit + allParam);
  }

  getSingleJobType(id: string) {
    return this.http.get('jobCategory/' + id);
  }

  createJobType(credential: any) {
    return this.http.post('jobCategory', credential);
  }

  updateJobType(id: string, credential: any) {
    return this.http.put('jobCategory/' + id, credential);
  }

  archiveJobType(id: string) {
    return this.http.put('jobCategory/archive/' + id);
  }

  unarchiveJobType(id: string) {
    return this.http.put('jobCategory/unarchive/' + id);
  }

  deleteJobType(id: string) {
    return this.http.delete('jobCategory/' + id);
  }

  getGlobalJobTypeListing() {
    return this.http.get('jobCategory/globalListDropdown');
  }

  getJobTypeDropdownListingByFirmId(firmId: string) {
    return this.http.get('jobCategory/firm/'+firmId+'/listDropdown');
  }
  
  getJobTypeAssociations(id: string): Promise<any> {
    return lastValueFrom(this.http.get('jobCategory/associations/' + id));
  }
}
